import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../store/stores.js";
import { __, _i } from "../../../utils/i18n.js";
const DashboardCacheCardContent = observer(()=>{
    const { optionStore: { others: { cachePlugins } } } = useStores();
    const cachePluginLabels = Object.values(cachePlugins).join(", ");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Real Cookie Banner can empty your page cache automatically as soon as a page cache is detected. This means that you do not have to manually clear your page cache if you make changes to the cookie banner via the customizer or if you ask for a new consent.")
            }),
            cachePluginLabels ? /*#__PURE__*/ _jsx(Badge, {
                status: "success",
                text: _i(__("We have detected {{strong}}%s{{/strong}} as your page cache.", cachePluginLabels), {
                    strong: /*#__PURE__*/ _jsx("strong", {})
                })
            }) : /*#__PURE__*/ _jsx(Badge, {
                status: "default",
                text: _i(__("We did {{strong}}not detect{{/strong}} any page cache on your site."), {
                    strong: /*#__PURE__*/ _jsx("strong", {})
                })
            })
        ]
    });
});
export { DashboardCacheCardContent };
